export const createUnencodedQueryString = function(searchParams) {
    let queryString = '';
    for (const [key, value] of searchParams) {
        if (queryString !== '') {
            queryString += '&';
        }
        queryString += key + '=' + value;
    }
    return queryString;
};
